import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getFilters = ({ slug, params }) => axios.get(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/filter/conditions`, { params })
const updateFilters = ({ slug, formData }) => axios.patch(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/filter/conditions`, formData)
const deleteFilters = ({ slug, data }) => axios.delete(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/filter/conditions`, { data })
const deleteAllFilters = ({ slug, data }) => axios.delete(`${getWorkspaceId()}/campaigns/${slug}/rtb-settings/filter/conditions/clear`, { data })
const uploadCsvForFilter = ({ formData, config }) => axios.post(`${getWorkspaceId()}/campaigns/rtb-settings/filter/conditions/file`, formData, config)
const downloadFileExampleFilter = () => axios.get(`${getWorkspaceId()}/campaigns/rtb-settings/filter/conditions/file-example`)

export {
    getFilters,
    updateFilters,
    deleteFilters,
    deleteAllFilters,
    uploadCsvForFilter,
    downloadFileExampleFilter,
}
